import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as dayjs from 'dayjs';

export function isDateFirstOfMonth(control: AbstractControl): ValidationErrors | null {
  if (control.value && dayjs(control.value, 'YYYY-MM-DD', true).toDate().getDate() !== 1) {
    return { isDateFirstOfMonth: { value: control.value } };
  }
  return null;
}
